import { CcRequirementReviewMethod } from "server/models"
import { OrderType } from "client/utils"

export type CcRequirementReviewMethodValidation = { [key in keyof CcRequirementReviewMethod]?: string}

export interface CcRequirementReviewMethodList { [methodId: number]: CcRequirementReviewMethod }
export interface CcRequirementReviewMethodFilters {
    search?: string
}

export interface CcRequirementReviewMethodState {
    methodList: CcRequirementReviewMethodList
    methodIds: readonly number[]
    methodEdit: CcRequirementReviewMethod

    sortColumn: keyof CcRequirementReviewMethod
    sortOrder: OrderType
    filters: CcRequirementReviewMethodFilters

    reloadList: boolean
    reloadEdit: boolean
}

export const CC_REQUIREMENT_REVIEW_METHOD_LIST = "CC_REQUIREMENT_REVIEW_METHOD_LIST"
export const CC_REQUIREMENT_REVIEW_METHOD_IDS = "CC_REQUIREMENT_REVIEW_METHOD_IDS"
export const CC_REQUIREMENT_REVIEW_METHOD_EDIT = "CC_REQUIREMENT_REVIEW_METHOD_EDIT"

export const CC_REQUIREMENT_REVIEW_METHOD_SORT = "CC_REQUIREMENT_REVIEW_METHOD_SORT"
export const CC_REQUIREMENT_REVIEW_METHOD_FILTERS = "CC_REQUIREMENT_REVIEW_METHOD_FILTERS"

export const CC_REQUIREMENT_REVIEW_METHOD_RELOAD_LIST = "CC_REQUIREMENT_REVIEW_METHOD_RELOAD_LIST"
export const CC_REQUIREMENT_REVIEW_METHOD_RELOAD_EDIT = "CC_REQUIREMENT_REVIEW_METHOD_RELOAD_EDIT"
